import React from "react";
import { Link, useLocation } from "react-router-dom";
import SEO from "../components/SEO";
import { useSettings } from "../lib/settings";
import { CheckCircle2 } from "lucide-react";
import { T } from "../lib/autoTranslate";

const ThankYouPage = () => {
  const location = useLocation();
  const { settings } = useSettings();
  const s = settings || {};
  const heading = location.state?.heading || s.thank_you_heading || "Thank you.";
  const message = location.state?.message || s.thank_you_message || "We've received your request and will be in touch within a day.";
  const bookingTourTitle = location.state?.bookingTourTitle;

  return (
    <div className="pt-16">
      <SEO title="Thank you · Istanbul Free Walking Tours" description="Your request has been received." path="/thank-you" />
      <section className="section text-center">
        <div className="container-x max-w-[520px] mx-auto">
          <div className="mx-auto w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-6">
            <CheckCircle2 className="text-green-600" size={30} />
          </div>
          <p className="eyebrow mb-3"><T>Request received</T></p>
          <h1 className="font-serif-display text-[32px] md:text-[40px] leading-[1.1]"><T>{heading}</T></h1>
          {bookingTourTitle && (
            <p className="mt-3 text-[14px] text-[var(--ri-muted)]"><T>Booking request for</T> <strong>{bookingTourTitle}</strong></p>
          )}
          <div className="mt-4 text-[15.5px] leading-[1.75] text-[var(--ri-ink-soft)] rte-content">
            {/<[a-z][\s\S]*>/i.test(message) ? (
              <div dangerouslySetInnerHTML={{ __html: message }} />
            ) : (
              <p><T>{message}</T></p>
            )}
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-primary">Back to home</Link>
            <Link to="/tours" className="btn-outline">Browse tours</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ThankYouPage;
